import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Loader } from "../../utils";

/**
 * PublicRoute
 * Prevents logged-in users from accessing login/signup pages
 */
const PublicRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  // Subscribe to Redux state
  const { data: userData } = useSelector((state) => state.getCurrentUserDetails);

  const userType = userData?.account_type || localStorage.getItem("userType");
  const status = userData?.status || localStorage.getItem("isVerified");
  const rawOnboardingCompleted = userData?.onboarding_completed;
  const isOnboardingComplete = rawOnboardingCompleted === true || localStorage.getItem("onboardingCompleted") === "true";

  const rawStep = userData?.current_step;
  const currentStep = (rawStep !== undefined && rawStep !== null)
    ? (typeof rawStep === "string" ? (parseInt(rawStep.replace(/[^0-9]/g, ""), 10) || 1) : rawStep)
    : (parseInt(localStorage.getItem("currentStep"), 10) || 1);

  // const rawIsNewUser = userData?.is_new_business_user;
  // const isNewBusinessUser = rawIsNewUser !== undefined ? rawIsNewUser : localStorage.getItem("isNewBusinessUser") === "true";
  // If we have a token but don't know the userType yet, wait for it
  if (token && !userType) {
    return <Loader fullScreen={true} />;
  }

  // If user is authenticated and we know the type
  if (token) {
    if (userType === "user") {
      if (location.pathname !== "/dashboard") {
        return <Navigate to="/dashboard" replace />;
      }
      return children;
    }

    if (userType === "business") {
      if (status === "approved" && (isOnboardingComplete || currentStep >= 7)) {
        if (location.pathname !== "/dashboard") {
          return <Navigate to="/dashboard" replace />;
        }
        return children;
      }

      if (status === "submitted") {
        if (location.pathname !== "/verification-in-progress") {
          return <Navigate to="/verification-in-progress" replace />;
        }
        return children;
      }

      if (!isOnboardingComplete && currentStep < 7) {
        // Soft onboarding: If business user completed step 1, let them access dashboard
        if (currentStep >= 2) {
          if (location.pathname !== "/dashboard" && location.pathname !== "/onboarding") {
            return <Navigate to="/dashboard" replace />;
          }
          return children;
        }

        if (location.pathname !== "/onboarding") {
          return (
            <Navigate
              to="/onboarding"
              state={{ step: currentStep }}
              replace
            />
          );
        }
        return children;
      }

      // Default for business
      if (location.pathname !== "/dashboard") {
        return <Navigate to="/dashboard" replace />;
      }
      return children;
    }

    // fallback for unknown types or edge cases
    if (location.pathname !== "/dashboard" && location.pathname !== "/login" && location.pathname !== "/") {
      return children;
    }
    return <Navigate to="/dashboard" replace />;
  }

  // Not logged in → allow access
  return children;
};

export default PublicRoute;